import html2canvas from 'html2canvas';

const renderHtmlToBase64 = html => {
  return new Promise((resolve, reject) => {
    const iframe = document.createElement('iframe');
    iframe.style.cssText =
      'position:fixed;top:0;left:0;width:1800px;height:900px;opacity:0;pointer-events:none;z-index:-1;';
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<!DOCTYPE html><html><head><style>body{margin:0;background:#fff;}</style></head><body>${html}</body></html>`);
    iframeDoc.close();

    const waitForCharts = () => {
      const canvases = iframeDoc.querySelectorAll('canvas');
      if (canvases.length === 0) {
        setTimeout(waitForCharts, 200);
        return;
      }

      setTimeout(async () => {
        try {
          canvases.forEach(canvas => {
            const img = iframeDoc.createElement('img');
            img.src = canvas.toDataURL('image/png');
            img.style.width = canvas.style.width || canvas.width + 'px';
            img.style.height = canvas.style.height || canvas.height + 'px';
            canvas.parentNode.replaceChild(img, canvas);
          });

          const result = await html2canvas(iframeDoc.body, {
            backgroundColor: '#ffffff',
            scale: 2,
            useCORS: true,
            width: 1800,
            windowWidth: 1800
          });

          const base64 = result
            .toDataURL('image/png')
            .replace('data:image/png;base64,', '');

          document.body.removeChild(iframe);
          resolve(base64);
        } catch (err) {
          document.body.removeChild(iframe);
          reject(err);
        }
      }, 500);
    };

    setTimeout(waitForCharts, 1000);
  });
};

export { renderHtmlToBase64 };
